import { render, staticRenderFns } from "./url.vue?vue&type=template&id=194d9460&"
import script from "./url.vue?vue&type=script&lang=js&"
export * from "./url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194d9460')) {
      api.createRecord('194d9460', component.options)
    } else {
      api.reload('194d9460', component.options)
    }
    module.hot.accept("./url.vue?vue&type=template&id=194d9460&", function () {
      api.rerender('194d9460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/url.vue"
export default component.exports